import React from 'react';
import InputFlexBox from 'components/container/InputFlexBox';
import styled from 'styled-components';
import { ISupportLanguage } from 'utils/types/storyTypes';
import { IMinicut } from 'utils/types/resourceTypes';
import RightSideContent from './RightSideContent';
import LeftSideContent from './LeftSideContent';

interface IProps {
  supportLangList: ISupportLanguage[] | null;
  data: IMinicut | null;
  setData: React.Dispatch<React.SetStateAction<IMinicut | null>>;
}

const IllustUpdateWrapper: React.FC<IProps> = ({
  supportLangList,
  data,
  setData,
}) => {
  return (
    <div>
      <InputFlexBox>
        <ListFormLeftWrapping>
          <LeftSideContent
            data={data}
            setData={setData}
            supportLangList={supportLangList}
          />
        </ListFormLeftWrapping>
        <ListFormRightWrapping>
          <RightSideContent data={data} setData={setData} />
        </ListFormRightWrapping>
      </InputFlexBox>
    </div>
  );
};

export default IllustUpdateWrapper;

const ListFormLeftWrapping = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  row-gap: 24px;
  margin-right: 1.5rem;
`;
const ListFormRightWrapping = styled.div`
  width: 100%;
`;
